import React, { useEffect, useMemo, useState } from "react";
import DefaultModal from "../DefaultModal";
import LockedContainer from "./locked/LockedContainer";
import ModalPaymentPhone from "./payment_details/ModalPaymentPhone";
import ModalPaymentCard from "./payment_details/ModalPaymentCard";
import StepContainer from "./StepContainer.jsx";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../store/index.ts";
import "./top-up-balance.scss";
import { useReadLocalStorage } from "usehooks-ts";
import { ENUM_LCS_NAME } from "../../../store/enums.js";
import { dispatchCusEvent } from "../../../utils/utils.js";
import { ENUM_COMMON_EVENT } from "../../../hooks/common/useListener.js";

export default function TopUpBalance({ isOpen, closeModal, defaultDeposit }) {
  const { t } = useTranslation();
  const start_r = useReadLocalStorage(ENUM_LCS_NAME.startR) || "";

  const lockBonusClose = useAppSelector((state) => state.site.lock.balanceClose);
  const currency = useAppSelector((state) => state.user.currency);
  const isMobileSize = useAppSelector((state) => state.deviceSize.isMobileSize);

  const [lockedInfo, setLockedInfo] = useState(false);
  const [openPaymentPhone, setOpenPaymentPhone] = useState(false);
  const [openPaymentCard, setOpenPaymentCard] = useState(false);

  const title = useMemo(
    () =>
      currency ? t("Top up your balance in", { currency: currency }) : t("Top up your balance"),
    [currency, t]
  );

  useEffect(() => {
    if (isOpen) dispatchCusEvent(ENUM_COMMON_EVENT.checkCaptcha);
  }, [isOpen, start_r]);

  return (
    <>
      <DefaultModal
        isOpen={isOpen}
        classModal="top-up-balance"
        closeModal={!lockBonusClose && closeModal}
        hideClose={lockBonusClose}
        largeModal={!isMobileSize}
        miniModal={isMobileSize}>
        <LockedContainer locked={lockedInfo?.locked} lockedInfo={lockedInfo}>
          <h2>{title}</h2>

          <StepContainer
            defaultDeposit={defaultDeposit}
            isOpen={isOpen}
            closeModal={closeModal}
            setLockedInfo={setLockedInfo}
            lockedInfo={lockedInfo}
            setOpenPaymentCard={setOpenPaymentCard}
            setOpenPaymentPhone={setOpenPaymentPhone}
          />
        </LockedContainer>
      </DefaultModal>

      <ModalPaymentPhone
        isOpen={!!openPaymentPhone}
        closeModal={() => {
          setOpenPaymentPhone(false);
          closeModal();
        }}
        data={openPaymentPhone}
      />

      <ModalPaymentCard
        isOpen={!!openPaymentCard}
        data={openPaymentCard}
        closeModal={() => {
          setOpenPaymentCard(false);
          closeModal();
        }}
      />
    </>
  );
}
